import get from 'lodash/get';

export const selectError = (state) => get(state, 'settings.changePassword.error', false);

export const selectMessage = (state) => get(state, 'settings.changePassword.message', '');
